import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CreateRolesFormData } from "../schema/CreateRolesSchema";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";
import { CreateRoleResponse } from "../response/CreateRoleResponse";

export const useCreateRole = () => {
    return useMutation({
        mutationFn: async (formData: CreateRolesFormData) => await privateApi.post(`/v4/role`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = CreateRoleResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid role data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create role', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid role data format");
            } else {
                console.error(`Failed to create role`, error);
                throw error;
            }
        }
    });
};